import { getStore } from "../store/store";
import type { ChatAnswer } from "owa-search-copilot-answer-shared";

export function getCopilotSearchAnswer(): ChatAnswer | undefined {
    return getStore().chatAnswer;
}

export function getIsLoading(): boolean {
    return getStore().isLoading;
}

export function getCurrentQuery(): string | undefined {
    return getStore().currentQuery;
}

export function getIsScrollMinimized(): boolean {
    return getStore().isScrollMinimized;
}

export function getHasManuallyTriggered(): boolean {
    return getStore().hasManuallyTriggered;
}
